<template>
    <div v-if="showReviews">
        <v-tooltip bottom v-if="reviewCount > 0">
            <template v-slot:activator="{ on }">
                <div v-on="on" class="d-inline-block">
                    <v-rating
                        content-class="d-inline-block"
                        v-model="preparedRating"
                        :background-color="backgroundColor"
                        :color="color"
                        dense
                        half-increments
                        readonly
                        :size="size"
                    />
                </div>
            </template>

            <span>{{reviewCount}} Kundenbewertung(en)</span>
        </v-tooltip>

        <v-rating
            v-else
            v-model="preparedRating"
            :background-color="backgroundColor"
            :color="color"
            dense
            half-increments
            readonly
            :size="size"
        />
    </div>
</template>

<script>
export default {
    name: 'AverageRating',
    props: {
        color: {
            type: String,
            default: 'black'
        },
        backgroundColor: {
            type: String,
            default: 'accent'
        },
        size: {
            type: Number | String,
            default: 18
        },
        showReviews: Boolean,
        rating: Number | String,
        reviewCount: Number | String,
    },
    computed: {
        preparedRating() {
            return parseFloat(this.rating);
        }
    }
};
</script>